export const GET_RECONCILIATION_ACTION_TYPE =
  'reconciliation/getReconciliations';

export const LIMIT = { limit: 100, page: 1 };

export const RECONCILIATIONS_PROPS = {
  RECONCILIATIONS: {
    SELECT_TYPE: 'Select Type',
    TYPE: 'Type',
  },
  DATEFILTERBY: {
    SELECT_TYPE: 'Select Date Filter',
    DATE_FILTER: 'Date Filter',
  },
};

export const RECONCILIATION_TYPES = [
  {
    id: '1',
    name: 'All Types',
  },
  {
    id: 'vdiPeriodTotals',
    name: 'VDI Period Totals',
  },
  {
    id: 'vdiPeriodSalesTransactions',
    name: 'VDI Period Sales Transactions',
  },
  {
    id: 'vdiProductSaleTransactionDetails',
    name: 'VDI Product Sales Transaction Details',
  },
];

export const RECONCILIATION_TABLE_PROPS = {
  COLUMNS: {
    REPORT_ID: 'Report Id',
    REQUEST_BY: 'Request By',
    REPORT_BY: 'Report By',
    TYPE: 'Type',
    OPERATOR: 'Operator',
    TRANSACTION_DTM: 'Transaction Dtm',
    REQUESTER_DATE_RANGE: 'Requester Date Range',
    ACTIONS: 'Actions',
  },
  MENU: {
    VIEW_REQUEST_TITLE: 'Request Payload',
    VIEW_REPORT_TITLE: 'Report',
    DOWNLOAD_REPORT_TITLE: 'Download Report',
    VIEW_REQUEST_LABEL: 'View Request',
    VIEW_REPORT_LABEL: 'View Report',
    DOWNLOAD_REPORT_LABEL: 'Download Report',
  },
  MODAL: {
    CLOSE_BUTTON: 'Close',
  },
};

export const RECONCILIATION_REPORTS_RESPONSE = {
  DOWNLOAD: {
    SUCCESS: 'Successfully Downloaded',
  },
};

export const RECONCILIATION_DATE_EFILTER = [
  {
    queryParam: 'transactionDtm',
    name: 'Transaction Dtm',
  },
  {
    queryParam: 'reconcileDtm',
    name: 'Reconcile Dtm',
  },
];
